import { render, staticRenderFns } from "./AS_AboutSideNav.vue?vue&type=template&id=4ed92956&scoped=true&"
import script from "./AS_AboutSideNav.vue?vue&type=script&lang=js&"
export * from "./AS_AboutSideNav.vue?vue&type=script&lang=js&"
import style0 from "./AS_AboutSideNav.vue?vue&type=style&index=0&id=4ed92956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed92956",
  null
  
)

export default component.exports